import { DefaultFocusStatusModel } from "../../../models/DefaultFocusStatusModel";
import { KeyboardNavigation } from "./KeyboardNavigation";

export class NumericRankingNavigation extends KeyboardNavigation {
    // `statuses` is global: same questionId + variableId is required, not questionId alone (e.g. variableId 0).
    private findAdjacentFocusableElementWithinCurrentVariable(
        currentElement: DefaultFocusStatusModel,
        step: 1 | -1,
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);
        const statuses = this.defaultFocusStatus.statuses;

        for (
            let i = index + step;
            step > 0 ? i < statuses.length : i >= 0;
            i += step
        ) {
            const elementFocusStatus = statuses[i];
            if (
                elementFocusStatus.variableId === currentElement.variableId &&
                elementFocusStatus.questionId === currentElement.questionId &&
                elementFocusStatus.elementId !== currentElement.elementId &&
                elementFocusStatus.elementRef?.current
            ) {
                return this.getFocusableElement(
                    elementFocusStatus,
                    step === 1,
                );
            }
        }

        return null;
    }

    findNextFocusableElementWithinCurrentVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        return this.findAdjacentFocusableElementWithinCurrentVariable(currentElement, 1);
    }

    findPreviousFocusableElementWithinCurrentVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        return this.findAdjacentFocusableElementWithinCurrentVariable(currentElement, -1);
    }

    findNextFocusableElementWithinSameVariable(
        currentElement: DefaultFocusStatusModel,
        eventKey: string,
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        if (eventKey === "ArrowDown" || eventKey === "ArrowRight") {
            for (let i = index; i < this.defaultFocusStatus.statuses.length; i++) {
                const elementFocusStatus = this.defaultFocusStatus.statuses[i];

                if (
                    elementFocusStatus.variableId === currentElement.variableId &&
                    elementFocusStatus.elementId !== currentElement.elementId &&
                    elementFocusStatus.elementRef?.current
                ) {
                    return this.getFocusableElement(elementFocusStatus, true);
                }
            }
        } else if (eventKey === "ArrowUp" || eventKey === "ArrowLeft") {
            for (let i = index; i >= 0; i--) {
                const elementFocusStatus = this.defaultFocusStatus.statuses[i];
                if (
                    elementFocusStatus.variableId === currentElement.variableId &&
                    elementFocusStatus.elementId !== currentElement.elementId &&
                    elementFocusStatus.elementRef?.current
                ) {
                    return this.getFocusableElement(elementFocusStatus);
                }
            }
        }

        return null;
    }

    findNextFocusableElementWithinNextVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        const nextElementWithinCurrentVariable =
            this.findNextFocusableElementWithinCurrentVariable(currentElement);
        if (nextElementWithinCurrentVariable) {
            return nextElementWithinCurrentVariable;
        }

        return this.findNextFocusableElementWithinNextVariableCommon(currentElement);
    }

    findLastFocusableElementWithinPreviousVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        const previousElementWithinCurrentVariable =
            this.findPreviousFocusableElementWithinCurrentVariable(currentElement);
        if (previousElementWithinCurrentVariable) {
            return previousElementWithinCurrentVariable;
        }

        return this.findLastFocusableElementWithinPreviousVariableCommon(
            currentElement,
        );
    }
}
